import React from 'react';
import { useSelector } from 'react-redux';
import { ActionMenu } from '@milanote/roma/application';
import { FilePicker, Popover } from '@milanote/roma';
import { Button } from 'react-aria-components';

import Icon from '../../../../../components/icons/Icon';
import { selectIsTabletFormFactor } from '../../../../../platform/platformSelector';
import ElementContextMenuV2 from '../../../../contextMenuV2/ElementContextMenuV2';
import {
    elementDesktopToolbarMenuConfig,
    elementTabletToolbarMenuConfig,
} from '../../../../contextMenuV2/configs/elementContextMenuConfig';
import useToolbarPopover from '../../../hooks/useToolbarPopover';
import ToolbarTool from '../../ToolbarTool';

// TODO WEB-16910: Share More tool styling without relying on legacy popup class names.
import '../../moreTool/MoreTool.scss';

export const DESKTOP_ELEMENT_CONTEXT_MENU_TOOL_ID = 'DESKTOP_CONTEXT_MENU';

type DesktopElementContextMenuToolProps = {
    name?: string;
};

/**
 * Opens the shared element menu from the selected-element toolbar.
 * TODO WEB-16910: Consolidate the shared More tool shell with TableContextMenuTool.
 */
const DesktopElementContextMenuTool: React.FC<DesktopElementContextMenuToolProps> = ({
    name = 'More',
    ...toolProps
}) => {
    const isTablet = useSelector(selectIsTabletFormFactor);
    const { isOpen, onOpenChange } = useToolbarPopover();
    const menuConfig = isTablet ? elementTabletToolbarMenuConfig : elementDesktopToolbarMenuConfig;

    return (
        <FilePicker.Provider>
            <div className="MoreTool ToolbarPopupTool">
                <Popover.MenuTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
                    <Button className="Button" aria-label={name}>
                        <ToolbarTool {...toolProps} isOpen={isOpen} tooltipEnabled={!isOpen}>
                            <Icon name="toolbar-more" />
                        </ToolbarTool>
                    </Button>
                    <Popover className={ActionMenu.styles.width} placement="end top" offset={4} crossOffset={6}>
                        <ElementContextMenuV2 isEditable menuConfig={menuConfig} size="sm" />
                    </Popover>
                </Popover.MenuTrigger>
            </div>
        </FilePicker.Provider>
    );
};

export default DesktopElementContextMenuTool;
